import { Reducer } from '@reduxjs/toolkit';
import { ApiAndDataSource } from '../app.slice';

const appApiDatasourceReducer: Reducer<ApiAndDataSource> = (state, { payload }) => {
  if (!state) {
    return {
      api: null, dataSource: null, objectCache: null,
    };
  }

  if (!payload) {
    return state;
  }

  return { ...state, ...payload };
};

export default appApiDatasourceReducer;
